import { useCallback } from 'react';
import { DetailedOptionType } from '../types';
import { OptionType } from '../types';

export interface SearchResult {
    items: OptionType[];
    moreOptionsCount: number;
}

export const useOkpd2 = () => {
    const fetchRootOptions = useCallback<
        () => Promise<OptionType[]>
    >(async () => {
        try {
            const res = await fetch('/api/okpd2', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return await res.json();
        } catch (err) {
            return [];
        }
    }, []);

    const fetchOption = useCallback<
        (item: Pick<OptionType, 'code'>) => Promise<DetailedOptionType>
    >(async (item) => {
        try {
            const res = await fetch(`/api/okpd2/${item.code}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return await res.json();
        } catch (err) {
            return [];
        }
    }, []);

    const searchOptions = useCallback<(query: string) => Promise<SearchResult>>(
        async (query) => {
            try {
                const res = await fetch(
                    `/api/okpd2/search?query=${encodeURIComponent(query)}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                );

                const data = await res.json();

                return data as SearchResult;
            } catch (err) {
                return {
                    items: [],
                    moreOptionsCount: 0,
                };
            }
        },
        []
    );

    return { fetchRootOptions, fetchOption, searchOptions };
};
